import { CountUp } from './countUp.min.js';

function setUpCountUp(targetElementId, targetValue) {
  var onFinished = () => {
    document.getElementById(targetElementId).innerHTML += '+';
  }

  var countUp = new CountUp(targetElementId, targetValue, {separator: '.', onCompleteCallback: onFinished, enableScrollSpy: true, scrollSpyOnce: true});
  countUp.start();
}

document.addEventListener('DOMContentLoaded', function() {
  // Get all number-fact blocks
  var numberFactBlocks = document.querySelectorAll('.pp-trust__card__title.pp-number-fact');

  numberFactBlocks.forEach((block, index) => {
    // Get the target value from the block's data-number attribute
    var targetValue = block.dataset.number;

    setUpCountUp(block.id, targetValue);
  });
});